module.exports = __webpack_public_path__ + "static/img/ManagePeople.c329d6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xinyuan/ManagePeople.png
// module id = tzZX
// module chunks = 0